import React from "react";
import SvgIcon from "@mui/material/SvgIcon";

export default function SkuflixFullscreenIcon(props) {
  return (
    <SvgIcon viewBox="0 0 24 24" {...props}>
      <path
        d="M7.90279 2.82031H4.82987C4.28654 2.82031 3.76547 3.03615 3.38128 3.42034C2.99709 3.80453 2.78125 4.3256 2.78125 4.86893V7.94185"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M21.2182 7.94185V4.86893C21.2182 4.3256 21.0024 3.80453 20.6182 3.42034C20.234 3.03615 19.7129 2.82031 19.1696 2.82031H16.0967"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M2.78125 16.1406V19.2136C2.78125 19.7569 2.99709 20.278 3.38128 20.6621C3.76547 21.0463 4.28654 21.2622 4.82987 21.2622H7.90279"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M16.0967 21.2622H19.1696C19.7129 21.2622 20.234 21.0463 20.6182 20.6621C21.0024 20.278 21.2182 19.7569 21.2182 19.2136V16.1406"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </SvgIcon>
  );
}
